import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BaseEditComponent } from "../../core/common/base-component";
import { FormUtil } from "../../core/form.util";
import { CouponsService } from "../services/coupons.service";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-coupons-edit",
  templateUrl: "./coupons-edit.component.html",
  styleUrls: ["./coupons-edit.component.css"]
})
export class CouponsEditComponent extends BaseEditComponent implements OnInit, OnDestroy {
  public CouponsData: any = {};
  public isCreateMode = true;

  public errors: any = {};

  public chosenSubscriptionPlans = false;

  public breadcrumb: any[] = ["Coupons", "Add New"];

  constructor(private router: Router, private couponsService: CouponsService, private titleService: Title) {
    super();
    alertify.logPosition("bottom right");
  }

  ngOnInit() {
    this.titleService.setTitle(`New Coupon | CODE Hospitality CMS`);
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  public breadcrumbGoTo(data) {
    this.router.navigate(["/admin/coupons"]);
  }

  importMode(val: boolean) {
    this.isCreateMode = val;
  }

  public create(form) {
    if (!FormUtil.isValid(form)) {
      return;
    }

    const reqData: any = { ...this.CouponsData };

    const methodName = this.isCreateMode ? "addCoupon" : "importCoupon";

    this.loading = true;
    this.couponsService[methodName](reqData).subscribe(
      _ => {
        this.loading = false;
        this.cancel();
      },
      err => {
        this.loading = false;
        this.alertError(err);
      }
    );
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      if (error.status === 400 && error.error === "IMPORT_FAILED") {
        alertify.error(
          `Stripe import failed, please check again Stripe ID and try again.`
        );
      } else if (
        error.status === 400 &&
        error.error === "INVALID_COUPON_TYPE"
      ) {
        alertify.error(`The created coupon in Stripe is not supported`);
      } else if (
        error.status === 400 &&
        error.error === "COUPON_ALREADY_EXISTS"
      ) {
        alertify.error(`The coupon with this name already exists`);
      } else {
        alertify.error(
          `There was a ${error.status} error with message '${error.error}'.`
        );
      }
    }
  }

  public cancel() {
    const url = "/admin/coupons";
    this.router.navigateByUrl(url);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/coupons/coupons-edit/coupons-edit.component.ts